import type { components } from '../schema/docs/api/admin';
import { throwOnError } from './utils';

type PrivateMoney = components['schemas']['PrivateMoney'];

type PrivateMoneyExchange = {
  id: number;
  created_at: string;
  updated_at: string;
  sender_money: PrivateMoney;
  receiver_money: PrivateMoney;
};

type Paginated<T> = {
  rows: T[];
  count: number;
  pagination: {
    current: number;
    has_next: boolean;
    has_prev: boolean;
    max_page: number;
    per_page: number;
  };
};

type GetPrivateMoneyExchangesResponse = Paginated<PrivateMoneyExchange>;

export const getPrivateMoneyExchanges = (query = '') =>
  fetch(`/api/private-money-exchange-permissions?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<GetPrivateMoneyExchangesResponse>);

export const createPrivateMoneyExchange = (postData: Record<string, unknown> = {}) =>
  fetch('/api/private-money-exchange-permissions', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: window._csrf_token, ...postData }),
  }).then(throwOnError<PrivateMoneyExchange>);

export const deletePrivateMoneyExchage = (id: string) => 
  fetch(`/api/private-money-exchange-permissions/${id}`, {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: window._csrf_token }),
  }).then(throwOnError);
